import script from "./budget-set-imports-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./budget-set-imports-button.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__